import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RecruitmentApiService } from '../../services/recruitment-api.service';
import { RecruitmentBenchmark } from '../models/recruitment.models';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-benchmark-list',
  templateUrl: './benchmark-list.component.html',
  styleUrls: ['./benchmark-list.component.css'],
  standalone: false,
})
export class BenchmarkListComponent implements OnInit {
  benchmarks: RecruitmentBenchmark[] = [];
  filteredBenchmarks: RecruitmentBenchmark[] = [];
  search = '';
  loading = true;
  errorMessage = '';

  constructor(
    private recruitmentApi: RecruitmentApiService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadBenchmarks();
  }

  loadBenchmarks(): void {
    this.loading = true;
    this.errorMessage = '';
    this.recruitmentApi.getBenchmarks().subscribe({
      next: (benchmarks) => {
        this.benchmarks = benchmarks;
        this.applySearch();
        this.loading = false;
      },
      error: () => {
        this.errorMessage = 'Private role benchmarks could not be loaded.';
        this.loading = false;
      },
    });
  }

  applySearch(): void {
    const query = this.search.trim().toLowerCase();
    this.filteredBenchmarks = !query ? [...this.benchmarks] : this.benchmarks.filter((benchmark) =>
      `${benchmark.roleTitle} ${benchmark.department} ${benchmark.description}`.toLowerCase().includes(query)
    );
  }

  progress(benchmark: RecruitmentBenchmark): number {
    if (!benchmark.candidateCount) return 0;
    return Math.round((benchmark.evaluatedCount / benchmark.candidateCount) * 100);
  }

  get isAdmin(): boolean {
    return this.authService.getCurrentUser()?.role === 'admin';
  }

  createPrivateBenchmark(): void {
    this.openPrivateEditor();
  }

  editPrivateBenchmark(benchmark: RecruitmentBenchmark, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.openPrivateEditor(benchmark.benchmarkId);
  }

  private openPrivateEditor(privateBenchmarkId?: string): void {
    const orgId = this.route.snapshot.queryParamMap.get('orgId');
    this.router.navigate(['/manage-scores'], {
      queryParams: {
        mode: 'private',
        ...(orgId ? { orgId } : {}),
        ...(privateBenchmarkId ? { privateBenchmarkId } : {})
      }
    });
  }
}
